import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface ProductSpecification {
  [key: string]: string;
}

interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  description: string;
  longDescription: string;
  features: string[];
  images: string[];
  tags: string[];
  specification: ProductSpecification;
}

type MockProducts = {
  "1": Product;
  "2": Product;
  "3": Product;
  "4": Product;
};

export default function ProductDetail() {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [activeImage, setActiveImage] = useState(0);

  // 模拟产品数据
  const mockProducts: MockProducts = {
    "1": {
      id: "1",
      name: "多功能办公桌垫",
      price: 89.9,
      originalPrice: 129.9,
      description: "防水防滑，超大尺寸，提升办公体验",
      longDescription: "这款多功能办公桌垫采用高品质环保材质制作，具有防水、防滑、防刮等多种功能。超大尺寸设计，能够覆盖整个桌面，为您的办公用品提供全面保护。表面光滑细腻，鼠标移动更加流畅精准。底部采用防滑设计，确保桌垫在使用过程中不会随意移动。",
      features: [
        "高品质环保材质",
        "防水防污易清洁",
        "防滑底部设计",
        "超大尺寸覆盖",
        "提升鼠标精度",
        "保护桌面不受刮伤"
      ],
      images: [
        "https://picsum.photos/id/1/600/600",
        "https://picsum.photos/id/2/600/600",
        "https://picsum.photos/id/3/600/600",
        "https://picsum.photos/id/4/600/600"
      ],
      tags: ["防水防滑", "包邮", "品质保证"],
      specification: {
        "材质": "环保PVC",
        "尺寸": "80cm x 40cm",
        "厚度": "2mm",
        "颜色": "黑色、灰色、蓝色",
        "重量": "0.5kg",
        "包装": "OPP袋包装"
      }
    },
    "2": {
      id: "2",
      name: "人体工学办公椅",
      price: 1299.0,
      originalPrice: 1899.0,
      description: "人体工学设计，舒适支撑，缓解久坐疲劳",
      longDescription: "这款人体工学办公椅采用科学的人体工学设计，能够为您的身体提供全面的支撑，有效缓解长时间久坐带来的疲劳和不适。椅子配备可调节的头枕、腰枕和扶手，能够根据不同身高和体型进行个性化调整，确保最佳的坐姿和舒适度。坐垫采用高密度海绵填充，弹性十足且经久耐用。椅背采用网布设计，透气排汗，即使在炎热的夏季也能保持干爽舒适。",
      features: [
        "3D人体工学设计",
        "可调节头枕",
        "腰部支撑调节",
        "多角度后仰",
        "透气网布面料",
        "高强度铝合金脚架",
        "静音滚轮设计"
      ],
      images: [
        "https://picsum.photos/id/20/600/600",
        "https://picsum.photos/id/21/600/600",
        "https://picsum.photos/id/22/600/600",
        "https://picsum.photos/id/23/600/600"
      ],
      tags: ["人体工学", "舒适久坐", "高品质"],
      specification: {
        "材质": "网布+高密度海绵+铝合金",
        "颜色": "黑色、灰色、蓝色",
        "载重": "150kg",
        "椅座高度": "48-58cm",
        "椅背高度": "95-105cm",
        "扶手调节": "上下左右",
        "后仰角度": "90°-135°",
        "重量": "25kg",
        "包装尺寸": "78x65x42cm"
      }
    },
    "3": {
      id: "3",
      name: "智能文件整理架",
      price: 249.0,
      originalPrice: 329.0,
      description: "智能分类，自动归档，提升办公效率",
      longDescription: "这款智能文件整理架采用先进的文档识别技术，能够自动识别不同类型的文件并进行智能分类归档。内置多个分区，可根据文件类型、日期或重要性进行灵活组织。采用高强度ABS材质制作，结构稳固耐用。抽屉式设计，方便存取文件，同时保持桌面整洁有序。适用于办公室、书房等多种场景，是提升工作效率的必备工具。",
      features: [
        "智能文件识别",
        "多区域分类存储",
        "抽屉式设计",
        "高强度ABS材质",
        "防滑底部设计",
        "静音滑轨",
        "可堆叠设计"
      ],
      images: [
        "https://picsum.photos/id/30/600/600",
        "https://picsum.photos/id/31/600/600",
        "https://picsum.photos/id/32/600/600",
        "https://picsum.photos/id/33/600/600"
      ],
      tags: ["智能收纳", "高效整理", "耐用"],
      specification: {
        "材质": "ABS工程塑料",
        "颜色": "白色、灰色、黑色",
        "尺寸": "38x32x25cm",
        "层数": "3层抽屉",
        "每层容量": "约500张A4纸",
        "重量": "2.5kg",
        "安装方式": "免安装",
        "适用纸张": "A4及以下规格"
      }
    },
    "4": {
      id: "4",
      name: "无线蓝牙键盘",
      price: 199.0,
      originalPrice: 269.0,
      description: "多设备连接，静音按键，舒适打字体验",
      longDescription: "这款无线蓝牙键盘支持多设备连接，可同时连接电脑、平板和手机，轻松切换使用。采用剪刀脚结构设计，按键行程适中，打字手感舒适，同时具备静音效果，不会干扰他人。键盘采用紧凑型布局，节省桌面空间，同时保留常用功能键。内置大容量锂电池，一次充电可使用长达30天。表面采用防泼溅设计，有效保护内部电子元件。",
      features: [
        "蓝牙5.0多设备连接",
        "剪刀脚结构按键",
        "静音打字设计",
        "紧凑型布局",
        "长续航锂电池",
        "防泼溅保护",
        "自动休眠功能"
      ],
      images: [
        "https://picsum.photos/id/40/600/600",
        "https://picsum.photos/id/41/600/600",
        "https://picsum.photos/id/42/600/600",
        "https://picsum.photos/id/43/600/600"
      ],
      tags: ["无线蓝牙", "静音", "多设备"],
      specification: {
        "连接方式": "蓝牙5.0",
        "按键数": "84键",
        "按键寿命": "500万次",
        "电池容量": "300mAh",
        "充电时间": "约2小时",
        "续航时间": "30天（正常使用）",
        "尺寸": "280x120x20mm",
        "重量": "280g",
        "兼容系统": "Windows、MacOS、iOS、Android",
        "颜色": "黑色、白色、粉色"
      }
    }
  };

  useEffect(() => {
    // 模拟API请求延迟
    const timer = setTimeout(() => {
      if (id && mockProducts[id as keyof typeof mockProducts]) {
        setProduct(mockProducts[id as keyof typeof mockProducts]);
      }
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [id]);

  const handleAddToCart = () => {
    // 这里可以实现添加到购物车的逻辑
    alert(`已将 ${quantity} 个 ${product?.name} 加入购物车！`);
  };

  const handleQuantityChange = (change: number) => {
    const newQuantity = quantity + change;
    if (newQuantity > 0 && newQuantity <= 99) {
      setQuantity(newQuantity);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-2xl font-bold text-orange-500">加载中...</div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow flex items-center justify-center py-20">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">商品不存在</h2>
            <a href="/" className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium">返回首页</a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Breadcrumb */}
        <div className="bg-gray-50 py-3 border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center text-sm text-gray-500">
              <a href="/" className="hover:text-orange-500">首页</a>
              <span className="mx-2">/</span>
              {product.id === "2" && (
                <>
                  <a href="/category/furniture" className="hover:text-orange-500">办公家具</a>
                  <span className="mx-2">/</span>
                </>
              )}
              {(product.id === "1" || product.id === "3") && (
                <>
                  <a href="/category/office" className="hover:text-orange-500">办公用品</a>
                  <span className="mx-2">/</span>
                </>
              )}
              {product.id === "4" && (
                <>
                  <a href="/category/electronics" className="hover:text-orange-500">电子产品</a>
                  <span className="mx-2">/</span>
                </>
              )}
              <span className="text-gray-800 font-medium">{product.name}</span>
            </div>
          </div>
        </div>

        {/* Product Details */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Product Images */}
              <div>
                <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mb-4">
                  <img
                    src={product.images[activeImage]}
                    alt={`${product.name} - 主图`}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="grid grid-cols-4 gap-3">
                  {product.images.map((img: string, index: number) => (
                    <div
                      key={index}
                      className={`aspect-square bg-gray-100 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-orange-500 transition-all ${index === activeImage ? 'ring-2 ring-orange-500' : ''}`}
                      onClick={() => setActiveImage(index)}
                    >
                      <img
                        src={img}
                        alt={`${product.name} - 图片 ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Product Information */}
              <div>
                <div className="mb-6">
                  {product.tags.map((tag: string, index: number) => (
                    <span
                      key={index}
                      className="inline-block px-3 py-1 bg-orange-100 text-orange-600 text-xs rounded-full mr-2 mb-2"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <h1 className="text-3xl font-bold text-gray-800 mb-4">{product.name}</h1>
                
                <div className="mb-6">
                  <div className="flex items-baseline space-x-3">
                    <span className="text-3xl font-bold text-orange-500">¥{product.price.toFixed(2)}</span>
                    {product.originalPrice && product.originalPrice > product.price && (
                      <span className="text-xl text-gray-400 line-through">¥{product.originalPrice.toFixed(2)}</span>
                    )}
                    {product.originalPrice && product.originalPrice > product.price && (
                      <span className="text-sm text-orange-500 bg-orange-50 px-2 py-1 rounded">
                        省¥{(product.originalPrice - product.price).toFixed(2)}
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <p className="text-gray-600 mb-4">{product.description}</p>
                  <p className="text-gray-600 leading-relaxed">{product.longDescription}</p>
                </div>

                {/* Features List */}
                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">产品特点</h3>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {product.features.map((feature: string, index: number) => (
                      <li key={index} className="flex items-center text-gray-600">
                        <i className="ri-check-circle-line text-orange-500 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Quantity and Add to Cart */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <button
                      onClick={() => handleQuantityChange(-1)}
                      className="px-3 py-2 text-gray-500 hover:text-gray-700"
                    >
                      <i className="ri-minus-line"></i>
                    </button>
                    <input
                      type="number"
                      value={quantity}
                      min="1"
                      max="99"
                      readOnly
                      className="w-16 text-center border-x border-gray-300 py-2 text-gray-800"
                    />
                    <button
                      onClick={() => handleQuantityChange(1)}
                      className="px-3 py-2 text-gray-500 hover:text-gray-700"
                    >
                      <i className="ri-plus-line"></i>
                    </button>
                  </div>

                  <button
                    onClick={handleAddToCart}
                    className="flex-1 sm:flex-none bg-orange-500 hover:bg-orange-600 text-white py-3 px-8 rounded-lg font-medium flex items-center justify-center space-x-2"
                  >
                    <i className="ri-shopping-cart-line"></i>
                    <span>加入购物车</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Product Specifications */}
        <section className="py-12 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-8">产品规格</h2>
            <div className="bg-white rounded-lg shadow-sm p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Object.entries(product.specification).map(([key, value]) => (
                  <div key={key} className="flex py-3 border-b border-gray-100 last:border-b-0">
                    <span className="w-1/3 font-medium text-gray-500">{key}</span>
                    <span className="w-2/3 text-gray-800">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Customer Reviews */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-8">用户评价</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="flex items-center mb-4">
                  <img
                    src="https://picsum.photos/id/64/50/50"
                    alt="用户头像"
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <div className="font-semibold text-gray-800">张先生</div>
                    <div className="text-sm text-gray-500">2025-10-15</div>
                  </div>
                </div>
                <div className="text-yellow-400 mb-3">
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                </div>
                <p className="text-gray-600">质量非常好，尺寸合适，防水效果不错，鼠标移动很流畅，值得购买。</p>
              </div>
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="flex items-center mb-4">
                  <img
                    src="https://picsum.photos/id/65/50/50"
                    alt="用户头像"
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <div className="font-semibold text-gray-800">李女士</div>
                    <div className="text-sm text-gray-500">2025-10-10</div>
                  </div>
                </div>
                <div className="text-yellow-400 mb-3">
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                  <i className="ri-star-line"></i>
                </div>
                <p className="text-gray-600">做工精细，防滑效果好，颜色也很百搭，保护桌面效果不错，推荐购买。</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}